export default __webpack_public_path__ + "static/media/email-icon.843a921b.svg";